/* eslint-disable radix */
/* eslint-disable import/no-unresolved */
import { sortBy } from 'lodash';
import * as constants from 'common/constants/financials';
import { FinancialStatementPeriod } from 'common/types/financials';
import { updateNeedsActualizationState } from 'pages/Financials/utilities';
import { parseDatabaseValue } from 'utilities';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import rowConfig from '../data/rowConfig';
import { BalanceSheetCell, BalanceSheetRowConfig } from '../types';

const customReverseParser = ({
  cells,
  columns,
  allowEmptyValues,
  rowConfigParam,
  balanceSheetAttrs,
}: {
  cells: Record<string, BalanceSheetCell>;
  columns: FinancialStatementPeriod[];
  allowEmptyValues: boolean;
  rowConfigParam: BalanceSheetRowConfig[];
  balanceSheetAttrs: Record<string, BalanceSheetCell>;
}) => {
  let tableColumns: FinancialStatementPeriod[] = [];

  const sortedColumns = sortBy(columns, ['order']);
  const alphabet = alphabetGenerator([], sortedColumns.length);

  sortedColumns.forEach((column, columnIndex) => {
    const columnLegend = alphabet[columnIndex];
    // copy original values
    const tmpColumn = { ...column };
    const balanceSheetData = tmpColumn.balance_sheet!;

    // replace updated values
    rowConfigParam.forEach((cell, cellIndex) => {
      const key = columnLegend + (cellIndex + 1);
      const defaultValue = cell.defaultValue || null;
      const type = cell.dbType || null;
      const format = cell.format || null;
      const value = cells[key] ? cells[key].value : defaultValue;
      const { gridType } = cell;
      const decimalPlaces = balanceSheetAttrs[cell.alias]?.decimal_places;

      if (cell.alias && cells[key]) {
        balanceSheetData[cell.alias] = parseDatabaseValue({
          type,
          value,
          format,
          allowEmptyValues,
          gridType,
          decimalPlaces,
        });
      }
    });

    // calculate total debt value
    const shortTermDebt = Number(balanceSheetData.liabilities_short_term_debt);
    const longTermDebt = Number(balanceSheetData.liabilities_long_term_debt);
    const totalDebt =
      (Number.isNaN(shortTermDebt) ? 0 : shortTermDebt) + (Number.isNaN(longTermDebt) ? 0 : longTermDebt);

    balanceSheetData[constants.TOTAL_DEBT_ALIAS] = totalDebt;

    tableColumns = [...tableColumns, tmpColumn] as BalanceSheetCell[];
  });

  return tableColumns;
};

const reverseParser = ({
  cells,
  columns,
  fieldAttributes,
  allowEmptyValues = true,
}: {
  cells: Record<string, BalanceSheetCell>;
  columns: FinancialStatementPeriod[];
  fieldAttributes: Record<string, BalanceSheetCell>;
  allowEmptyValues: boolean;
}) => {
  const localConfig = rowConfig();
  const totalDebt = {
    value: constants.TOTAL_DEBT_TITLE,
    alias: constants.TOTAL_DEBT_ALIAS,
    hidden: false,
    readOnly: true,
    gridType: 'number',
    dbType: 'string',
    shortTermDebt: constants.LIABILITIES_SHORT_TERM_DEBT_ALIAS,
    longTermDebt: constants.LIABILITIES_LONG_TERM_DEBT_ALIAS,
  };
  localConfig.push(totalDebt);

  const baseReverseParsedColumns = customReverseParser({
    cells,
    columns,
    allowEmptyValues,
    balanceSheetAttrs: fieldAttributes,
    rowConfigParam: localConfig,
  });

  return updateNeedsActualizationState(baseReverseParsedColumns, cells);
};
export default reverseParser;
